import React, { useState, useEffect, useRef, useCallback } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import ProductCard from './ProductCard';
import apiService from '../services/nextlevelgames-api';

const FeaturedProducts = () => {
  const [products, setProducts] = useState(null);
  const scrollerRef = useRef(null);

  useEffect(() => {
    apiService
      .getFeaturedItems()
      .then((data) => setProducts(data.items || []))
      .catch(() => setProducts([]));
  }, []);

  const scrollByPage = useCallback((dir) => {
    const el = scrollerRef.current;
    if (el) el.scrollBy({ left: dir * el.clientWidth * 0.85, behavior: 'smooth' });
  }, []);

  if (products && products.length === 0) return null;

  return (
    <section className="py-8 bg-gradient-to-br from-navy via-[#173a6e] to-[#1f4f86]">
      <div className="container">
        <div className="text-center mb-4">
          <h2 className="heading-block !text-white text-4xl mb-2">
            Featured Products
          </h2>
          <p className="text-sky-100 max-w-2xl mx-auto">
            Check out our hottest items and newest arrivals
          </p>
        </div>

        <div className="relative group/scroller">
          <button
            onClick={() => scrollByPage(-1)}
            className="hidden md:flex absolute -left-6 top-1/3 z-10 p-3.5 rounded-full bg-gray-500/90 hover:bg-gray-600 shadow-lg opacity-0 group-hover/scroller:opacity-100 focus-visible:opacity-100 transition-opacity duration-200"
            aria-label="Scroll left"
          >
            <ChevronLeft className="w-7 h-7 text-white" />
          </button>
          <button
            onClick={() => scrollByPage(1)}
            className="hidden md:flex absolute -right-6 top-1/3 z-10 p-3.5 rounded-full bg-gray-500/90 hover:bg-gray-600 shadow-lg opacity-0 group-hover/scroller:opacity-100 focus-visible:opacity-100 transition-opacity duration-200"
            aria-label="Scroll right"
          >
            <ChevronRight className="w-7 h-7 text-white" />
          </button>

          <div
            ref={scrollerRef}
            className="flex gap-4 overflow-x-auto snap-x snap-mandatory pb-2 px-1 min-h-[300px] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
          >
            {!products ? (
              <div className="flex-1 flex items-center justify-center">
                <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-primary-600"></div>
              </div>
            ) : (
              products.map((product) => (
                <div key={product.id} className="snap-start flex-shrink-0 w-44 sm:w-52">
                  <ProductCard product={product} imageUrl={product.imageUrl} viewMode="showcase" ratio="square" theme="dark" />
                </div>
              ))
            )}
          </div>
        </div>

      </div>
    </section>
  );
};

export default FeaturedProducts;
